module.exports = __webpack_public_path__ + "static/media/moleculer_dep_1.ec589531.jpeg";